import { createFileRoute, redirect } from "@tanstack/react-router";

import { SetupPasskeyPage } from "../auth/setup-passkey-page.tsx";

export const Route = createFileRoute("/setup/passkey")({
  beforeLoad: async ({ context }) => {
    const user = await context.data.auth.currentUser();
    if (user?.isComplete !== true) {
      throw redirect({ to: "/sign-in" });
    }
    return { user };
  },
  component: SetupPasskeyPage,
});
